import { RicosViewer } from "./../ricos-viewer-next/index.js";
import { createWixRicosViewer } from "./WixRicosViewerNext.js";
const WixRicosViewer = createWixRicosViewer(RicosViewer);
export {
  WixRicosViewer
};
//# sourceMappingURL=index.js.map
